import { DataService } from "../../../../Autofacets-Core/src/app/services/data.service";
import { Urls } from "../../../../Autofacets-Core/src/app/utils/urls";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class PaymentMasterDataService {
    constructor(private dataProvider: DataService) {
    }

    async GetPaymentMethodDropdown(): Promise<any> {
        return this.dataProvider.GetAll<any>(Urls.GetPaymentMethod).toPromise();
    }
    async GetPaymentTermDropdown(): Promise<any> {
        return this.dataProvider.GetAll<any>(Urls.GetPaymentTerm).toPromise();
    }
    async GetReminderTermDropdown(): Promise<any> {
        return this.dataProvider.GetAll<any>(Urls.GetReminderTerm).toPromise();
    }
    async GetLaborandItemSalesPriceGroup(): Promise<any> {
        return this.dataProvider.GetAll<any>(Urls.GetLaborAndSalesPriceGroup).toPromise();
    }
}